import { parseProduct } from "@coworker/utils/products.helper";
import { useAllSalesLocationsForArticleQuery } from "./useAllSalesLocationsForArticleQuery";

export function useLocationCapacity(gridCode: string, fullId: string) {
  const [short_id, type] = parseProduct(fullId);
  const { data: locationsData } = useAllSalesLocationsForArticleQuery(
    !!type && !!short_id ? `${type}${short_id}` : ""
  );
  const found = locationsData?.find(
    (l: { location: string }) => gridCode === l.location
  );
  return found?.quantity || "";
}
